export const ERoutes = {
    Author: "/author",
    Careers: "/careers",
    Category: "/news/category",
    Contact: "#contact",
    Events: "/events",
    Home: "/",
    TheWire: "/news",
    Work: "/showcase",
    Services: "/services",
    About: "/about",
    Privacy: "/privacy-policy",
};

export const EMediaAndTextMediaPositionHorizontal = {
    LEFT: "Left",
    RIGHT: "Right",
};

export const EMediaAndTextMediaPositionVertical = {
    BOTTOM: "Bottom",
    TOP: "Top",
};

export const EMediaAndTextCopyAlignment = {
    LEFT: "Left",
    RIGHT: "Right",
    CENTER: "Center",
};

export const EMediaAndTextVerticalAlignment = {
    TOP: "Top",
    MIDDLE: "Middle",
    BOTTOM: "Bottom",
};

export const EGridItemAspectRatio = {
    ONE: "1:1",
    TWO: "2:1",
};

export const EMediaAndTextSecondColumnType = {
    MEDIA: "Media",
    TEXT: "Text",
};

export const EMediaAndTextColumnCount = {
    SINGLE: "Single",
    DOUBLE: "Double",
};

export const EMediaAndTextLayoutType = {
    MT: "Media and Text",
    MO: "Media Only",
    TO: "Text Only",
};

export const EButtonPosition = {
    TOP: "top",
    CENTER: "center",
    BOTTOM: "bottom",
};

export const ETitleFontSizes = {
    H1: "h1",
    H15: "h1-5",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    H5: "h5",
};

export const ETitleTextColCtaStyles = {
    TEXT_LINK: "Text Link",
    BLACK_BUTTON: "Black Button",
};

export const EHeroAspectRatios = {
    DEFAULT: "default",
    SHOWCASE: "showcase",
};

export const EFourColListDesktopLayout = {
    FOUR_COLUMNS: "Four Columns",
    TWO_BY_TWO: "Two by Two",
};
